
import { Vue, Watch, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import PermissionService, {
  AuthMenuSet,
  AuthEnum,
} from '@/services/permission.service';
import { KeyObject } from '@/common/interface';
import moment from 'moment';

@Component({})
export default class MainNav extends Vue {
  AuthEnum = AuthEnum;

  currentKeys: string[] = [];

  rootSubmenuKeys = [
    'main.work',
    'main.shop',
    'region',
    'main.bi',
    'main.order',
    'withdraw',
    'activity',
    'permission',
    'label',
    'audit',
    'lead',
    'log',
    'examine',
    'operation',
    'download',
    'main.shopcar',
    'auditCar.all',
    'main.shopcar.list',
    'main.orderCar',
    'main.order.list.b',
    'main.orderCar.list.b.notpay',
    'auditCar',
    'auditCarBi',
    'auditCar.list',
    'rescue',
    'rescue.bi',
  ];

  collectionKeys: any = {
    'main.black': [
      'main.work',
      'main.shop',
      'region',
      'main.bi',
      'main.order',
      'withdraw',
      'activity',
      'label',
      'audit',
      'operation',
    ],
    rescue: [
      'rescue.bi',
    ],
    'main.car': [
      'main.shopcar',
      'auditCar.all',
      'main.shopcar.list',
      'main.orderCar',
      'main.order.list.b',
      'main.orderCar.list.b.notpay',
      'auditCar',
      'auditCarBi',
      'auditCar.list',
    ],

    permission: [],
    account: [],
  };

  openKeys = ['main.black', 'main.car', 'main.work', 'main.shop'];

  allKeyS = [
    {
      key: 'main.black',
      childs: [
        {
          key: 'main.work',
          childs: [
            {
              key: 'workbenches.index',
            },
          ],
        },
        {
          key: 'main.shop',
          childs: [
            {
              key: 'main.shop.list',
            },
            {
              key: 'main.shop.detail',
            },
            {
              key: 'main.shop.virtualDetail',
            },
            {
              key: 'main.shop.all',
            },
            {
              key: 'main.shop.operation',
            },
            {
              key: 'main.shop.goods',
            },
            {
              key: 'main.shop.profile',
            },
            {
              key: 'main.shop.virtualPOIList',
            },
            {
              key: 'main.shop.customerFundingKA',
            },
            {
              key: 'main.shop.customerFunding',
            },
          ],
        },
        {
          key: 'spu',
          childs: [
            {
              key: 'spu.platform',
            },
            {
              key: 'spu.ka',
            },
            {
              key: 'spu.leading',
            },
            {
              key: 'spu.services',
            },
            {
              key: 'spu.defaultServices',
            },
            {
              key: 'spu.classificationList',
            },
            {
              key: 'spu.product.deletion',
            },
            {
              key: 'spu.productLog',
            },
          ],
        },
        {
          key: 'region',
          childs: [
            {
              key: 'region.covered',
            },
          ],
        },
        {
          key: 'main.bi',
        },
        {
          key: 'main.order',
          childs: [
            {
              key: 'main.order.list.b',
            },
            {
              key: 'main.order.list.b.notpay',
            },
            {
              key: 'main.order.list.c',
            },
            {
              key: 'invoice.index',
            },
            {
              key: 'invoice.invoiceIng',
            },
            {
              key: 'invoice.management',
            },
            {
              key: 'main.order.refund.b',
            },
            {
              key: 'main.order.settlement',
            },
            {
              key: 'main.order.paymentvoucher',
            },
            {
              key: 'main.order_black.statement',
            },
          ],
        },
        {
          key: 'withdraw',
          childs: [
            {
              key: 'withdraw.list',
            },
            {
              key: 'withdraw.apply',
            },
            {
              key: 'withdraw.examine',
            },
            {
              key: 'withdraw.AuditDetails',
            },
            {
              key: 'withdraw.SettlementDoc',
            },
          ],
        },
        {
          key: 'activity',
          childs: [
            {
              key: 'activity.list',
            },
          ],
        },
        {
          key: 'permission',
        },
        {
          key: 'label',
          childs: [
            {
              key: 'label.list',
            },
          ],
        },
        {
          key: 'audit',
          childs: [
            {
              key: 'audit.all',
            },
            {
              key: 'audit.list',
            },
            {
              key: 'audit.composite',
            },
            {
              key: 'audit.task',
            },
            {
              key: 'audit.detail',
            },
          ],
        },
        {
          key: 'operation',
          childs: [
            {
              key: 'operation.storeOperation',
            },
            {
              key: 'operation.batchManagement',
            },
          ],
        },

      ],
    },
    {
      key: 'main.car',
      childs: [
        {
          key: 'main.shopcar',
          childs: [
            {
              key: 'car.index',
            },
            {
              key: 'car.detail',
            },
            {
              key: 'carlist.index',
            },
          ],
        },
        {
          key: 'main.orderCar',
          childs: [
            {
              key: 'carorder.index',
            },
            {
              key: 'carorder.notpay',
            },
            {
              key: 'carorder.voucher',
            },
            {
              key: 'carorder.settlement',
            },
            {
              key: 'carorder.d_refund',
            },
            {
              key: 'carorder.statement',
            },
          ],
        },
        {
          key: 'auditCarBi',
        },
        {
          key: 'auditCar',
          childs: [
            {
              key: 'caraudit.index',
            },
            {
              key: 'caraudit.carlist',
            },
            {
              key: 'caraudit.taskdetail',
            },
            {
              key: 'caraudit.detail',
            },
          ],
        },
      ],
    },
    {
      key: 'rescue',
      childs: [
        {
          key: 'rescue.bi',
          childs: [],
        },
      ],
    },
    {
      key: 'permission',
      childs: [
        { key: 'permission.list' },
        { key: 'organization.list' },
        { key: 'organization.detail' },
      ],
    },
    {
      key: 'account',
      childs: [
        {
          key: 'account.brand',
          childs: [
            { key: 'account.album-template' },
            { key: 'account.brand_album_log' },
          ],
        },
        { key: 'account.agent' },
        { key: 'account.agency-operation' },
        { key: 'account.user' },
        { key: 'account.department' },
      ],
    },
    {
      key: 'lead',
      childs: [
        { key: 'lead.push' },
      ],
    },
    {
      key: 'examine',
      childs: [
        { key: 'examine.shop' },
        { key: 'examine.summary' },
        { key: 'examine.research' },
      ],
    },
    {
      key: 'log',
      childs: [
        { key: 'system.config' },
      ],
    },
  ];

  menuPermissions: KeyObject<boolean> = {};

  @lazyInject(PermissionService)
  permissionService!: PermissionService;

  getmainbi() {
    return [];
  }
  @Watch('$route')
  subMenu() {
    const { name } = this.$route;
    // const _d: any = [];
    // _d[0] = name;
    // this.onOpenChange(_d);
    // console.log(name, '00000000000');

    const s = this.findParentKeys(this.allKeyS, name);
    if (!s) {
      return;
    }
    this.openKeys = s.reverse();
  }
  findParentKeys(tree: any, targetKey: any, path = []) {
    for (const node of tree) {
      if (node.key === targetKey) {
        return path; // 找到目标节点，返回当前路径（即所有父级 key）
      }

      if (node.childs && node.childs.length > 0) {
        const newPath: any = [...path, node.key]; // 将当前节点加入路径
        const result: any = this.findParentKeys(node.childs, targetKey, newPath);
        if (result) return result; // 如果在子树中找到，返回结果
      }
    }
    return null; // 未找到
  }

  created(): void {
    this.routeChange();
    this.asyncGetMenuPermissions();
    this.subMenu();
  }

  onOpenChange(openKeys: string[]) {
    const latestOpenKey = openKeys.find(
      (key) => this.openKeys.indexOf(key) === -1,
    );
    let latestOpenKeyCollection = '';
    Object.keys(this.collectionKeys).forEach((key) => {
      if (this.collectionKeys[key].indexOf(latestOpenKey as string) > -1) {
        latestOpenKeyCollection = key;
      }
    });
    if (this.rootSubmenuKeys.indexOf(latestOpenKey as string) === -1) {
      this.openKeys = [...[latestOpenKeyCollection], ...openKeys];
    } else {
      this.openKeys = latestOpenKey ? [...[latestOpenKeyCollection], ...[latestOpenKey]] : [];
    }
  }

  goToAdManagement() {
    // 新窗口打开 -> 推广通的投放管理
    // window.open(' https://ads.amap.com/gd-pc/ads-pc-home/agency', '_blank');
    window.open('https://tg.amap.com/agency#', '_blank');
  }

  /** 获取菜单相关权限 */
  async asyncGetMenuPermissions() {
    const $asyncP = await this.permissionService.asyncPermissions([
      ...AuthMenuSet,
    ]);
    $asyncP.subscribe(
      (menuPermissions: KeyObject<boolean>) => {
        if (menuPermissions) {
          this.menuPermissions = menuPermissions;
        } else {
          this.menuPermissions = {};
        }
      },
      () => {
        this.menuPermissions = {};
      },
    );
  }

  go(routeName: string): void {
    this.$router.push({ name: routeName });
  }

  goSett(routeName: string): void {
    const activeKey = '1';
    this.$router.push({
      name: routeName,
      query: {
        activeKey,
      },
    });
  }

  goIndata(routeName: string): void {
    const createStartTime = `${moment().subtract(1, 'month').format('YYYY-MM-DD')} 00:00:00`;
    const createEndTime = `${moment().format('YYYY-MM-DD')} 23:59:59`;
    this.$router.push({
      name: routeName,
      query: {
        createStartTime,
        createEndTime,
      },
    });
  }

  goBOrder(routeName: string): void {
    const applyTimeStart = `${moment().subtract(1, 'month').format('YYYY-MM-DD')}`;
    const applyTimeEnd = `${moment().format('YYYY-MM-DD')}`;
    this.$router.push({
      name: routeName,
      query: {
        createStartTime: applyTimeStart,
        createEndTime: applyTimeEnd,
      },
    });
  }

  goInvoice(routeName: string): void {
    const applyTimeStart = `${moment().subtract(1, 'month').format('YYYY-MM-DD')}`;
    const applyTimeEnd = `${moment().format('YYYY-MM-DD')}`;
    this.$router.push({
      name: routeName,
      query: {
        applyTimeStart,
        applyTimeEnd,
      },
    });
  }
  goWithdraw() {
    this.$router.push({
      name: 'withdraw.list',
      query: {
        status: '0',
      },
    });
  }

  goNotPayBOrderList() {
    const applyTimeStart = `${moment().subtract(1, 'month').format('YYYY-MM-DD')}`;
    const applyTimeEnd = `${moment().format('YYYY-MM-DD')}`;
    this.$router.push({
      name: 'main.order.list.b.notpay',
      query: {
        payStatus: '1',
        createStartTime: applyTimeStart,
        createEndTime: applyTimeEnd,
      },
    });
  }

  getShow(val: any) {
    const _a: any = [];
    val.forEach((item: any) => {
      _a.push(this.menuPermissions[item]);
    });
    return _a.includes(true);
  }

  @Watch('$route')
  routeChange(): void {
    const keys = this.$route.matched.map((r) => {
      return r.name as string;
    });

    if (this.$route.name === 'bi.embedded') {
      keys.push(
        decodeURIComponent(`/bi/embedded/${this.$route.params.category}`),
      );
      keys.push(decodeURIComponent(this.$route.fullPath));
    }

    this.currentKeys = keys;
  }
}
